import { ItemServiceFactory as DefaultItemServiceFactory } from 'spark-core-dx/services'
import { Manager } from 'spark-core-dx/managers'
import _ from 'lodash';
import { Operations } from '../../services/ItemServices';

class ConvokeObjectManager extends Manager {
    constructor(id,coreContext, coreState, itemServiceName, queryItemServiceName, operationName, isWarning) {
        super(coreContext, coreState, (coreContext.itemServiceFactory ?? DefaultItemServiceFactory).ItemServiceEnum[itemServiceName],"data");

        var factory = (coreContext.itemServiceFactory ?? DefaultItemServiceFactory);
        this._operationName = operationName;
        this._className = itemServiceName;
        this._itemService = factory.GetItemService(itemServiceName, coreState, coreContext, isWarning);
        this._queryItemService = factory.GetItemService(queryItemServiceName, coreState, coreContext, isWarning);
        this._ppItemService = factory.GetItemService("ProfilePreference", coreState, coreContext, isWarning);
        this._id = id;
        this._itemServiceFactory = coreContext.itemServiceFactory ?? DefaultItemServiceFactory;
        this.fieldData = {};
        this._coreContext = coreContext;
    }

    async Query({ model, params, queryParams, skip, take, id}) {
            let queryFilter = model;
            take = take ?? 50000
            if (typeof (model) === 'string') {
                queryFilter = this.buildJSONObjFilter({ filter: model, params, skip:(skip ?? 0), take });
            } else {
                queryFilter = { ...queryFilter, Take: queryFilter?.Take ?? take, Skip: queryFilter?.Skip ?? skip ?? 0 }
            }
            const opArgs = {queryParams, operationName:this._operationName,id,item:queryFilter,isItem:true,isWarning:true, itemServiceOverride: this._queryItemService};
            return this.RunOperation(opArgs).then((r) => {
                return r;
            });
        }

     async LoadMetadata(props) {
        if(!props){
            props = {
                clientId: this._coreContext.Profile.ClientId,
                forceReload: true,
                appId: this._coreContext.Profile.AppId
            };
        }

        if(!props.id){
            props.id = this._id;
        }
        
        await this.GetMetadata(props);
    }


    //convoke manager base class-mere with Source Object Mgr...
    async GetMetadata({id, forceReload}) {
            id = id ?? this._id;
            const className = `${this._className}|${id}`;
            this.MergeState({
                loadingMetadata: true
            })

            if (this.uiMetadata && !forceReload) {
               console.log("uiMetadata",this.uiMetadata);
               this.MergeState({
                    uiMetadata: this.uiMetadata,
                    loadingMetadata: false
                })

                return {
                    Items: this.uiMetadata,
                    Cached: true,
                }
            } else {

                return this._itemService.single(id).then(async (r) => {
                    if ((r?.length !== undefined && r?.first()?.Success) || r?.Success) {
                        let result = r.first();
                        for (const metadata of r.first().Items) {
                            let selectDataPromise = [];
                            metadata.Fields.forEach(x => {
                                if (x.DataJson || x.DataOperationItem || x.DataOperation)
                                    selectDataPromise.push(this.GetSelectData(x))
                            })
                        }
                    
                       const ppResultsList = await this._ppItemService.list(this.buildJSONObjFilter({
                            filter:`x => x.ClassName == className && x.ProfileId == profileId && x.IsActive == true && x.IsDeleted == false`,
                            params:{profileId:this._coreContext?.Profile?._id,className}}));
                            
                            const ppResults = ppResultsList[0];
                            if(ppResults?.Success && ppResults?.Items?.length > 0 && result?.Items?.length > 0){
                                result.Items[0].ProfilePreferences = ppResults.Items.first();
                            }
                            else{
                                result.Items[0].ProfilePreferences = {ClassName:className, ProfileId: this._coreContext?.Profile?._id,Depth:0,UserFieldPreferences:{},SavedFilters:[]};
                            }

                            this.MergeState({
                                uiMetadata: result.Items,
                                loadingMetadata: false
                            })
                            this.MergeGlobalCachedMetadata({
                                cachedUIMetadata: this.cachedUIMetadata ? _.uniqBy([...this.cachedUIMetadata, ...r.first().Items], '_id') : r.first().Items,
                            })
                       

                        return result;
                    }
                    else {
                        this.MergeState({
                            loadingMetadata: false
                        })
                        return r?.first();
                    }
                });
            }

    }

    getTotalItemCount(){
     let totalItemCount = this.GetState("totalItemCount");
     if(totalItemCount == 0)
        totalItemCount = null;

     return totalItemCount;
   }



    //Model can be string query or the actual JSON object
    //Force updates forces a rerender.
    //Params are the field names in the string query. 
    //Skip 0 based index, defines starting position. 
    //Take Amount of records to return from database.
    async search({id, searchModel, forceUpdate, queryParams, params, skip, take, itemServiceOverride }) {
             
        this.MergeState({
            loadingSearch: true,
            loadingMetadata: !this.uiMetadata,
            isLoadingBtn: true,
        })

        if (forceUpdate) {
           if (!this.uiMetadata || forceUpdate) {
                this.GetMetadata({id, forceReload: true});
            }
            
            return (
                this.Query({ model: searchModel, params, queryParams, skip, take, id, itemServiceOverride }).then((r) => {
                    if (r?.Success) {
                        const filteredData = r.Items?.first()?.Data ?? []
                        this.MergeState({
                            allData: filteredData,
                            loadingSearch: false,
                            totalItemCount: r.TotalItemCount,
                            isLoadingBtn: false,
                            filteredData: filteredData
                        })
                        return {Items: filteredData, TotalItemCount: r.TotalItemCount}
                    }
                    else if (r) {
                        this.MergeState({
                            allData: [],
                            loadingSearch: false,
                            totalItemCount: 0,
                            isLoadingBtn: false,
                        })
                                return {Items: [], TotalItemCount: 0}
                    }
                    else {
                        console.log("Search query returned undefined/null.");
                    }
                })
            )
        } else {
            this.MergeState({ loadingSearch: false, isLoadingBtn: false })
            return {Items: this.filteredData,TotalItemCount: this.getTotalItemCount()}
        }
    }

    async RunOperation({ operationName, id, item, queryParams, isFile, isItem, isWarning, processorType, itemServiceOverride }) {
        const resultFunction = (r) => {
            if ((r?.length !== undefined && r?.first()?.Success) || r?.Success) {
                if (r.first().UICommands && r.first().UICommands["UpdateTable"]) {
                    this._updateTableData(r.first())
                }

                if (r.first().UICommands && r.first().UICommands["RefreshTable"]) {
                    this.search({ forceUpdate: true })
                }
            }
            if(r.first().UICommands){
                this._coreContext.executeUICommands(r.first().UICommands,{Items: r.first().Items, Value: r.first().Value })
            }

            return r?.first();
        }
        
        let opResult;
        if (item) {
            opResult = await (itemServiceOverride ?? this._itemService).postOperation({ operationType: operationName, id, item, queryParams, isFile, isItem, isWarning, processorType }).then(resultFunction);
        }
        else {
            opResult = await (itemServiceOverride ?? this._itemService).getOperation({ operationType: operationName, id, queryParams, isFile, isWarning, processorType }).then(resultFunction);
        }
        return opResult;
    }

    getTotalItemCount(){
     let totalItemCount = this.GetState("totalItemCount");
     if(totalItemCount == 0)
        totalItemCount = null;

     return totalItemCount;
   }



    async saveItem(item) {
       throw "Save item not supported by convoke objects."
    }

    async deleteItem(item, deletePermanently) {
        throw "Delete not supported in Convoke.";
    }

    async GetFile(id, fileName) {
        throw "Get file not supported in convoke.";
    }

    async GetFileUrl(id) {
        throw "File Urls not supported in convoke.";
    }
}

export default ConvokeObjectManager;